<script setup lang="ts">
// A space's QR code at a size phones can scan: opens the space for its members (it's a
// link, not an invite, so it's harmless if someone else sees it).
import { computed } from 'vue'
import type { SpaceInfo } from '../api/types'
import { spaceUrl } from '../lib/qr'
import { useSession } from '../stores/session'
import Avatar from './Avatar.vue'
import Modal from './Modal.vue'

const props = defineProps<{ space: SpaceInfo }>()
const emit = defineEmits<{ close: [] }>()
const session = useSession()
const url = computed(() => spaceUrl(props.space.id))

async function copy(): Promise<void> {
  try {
    await navigator.clipboard.writeText(url.value)
    session.toast('Link copied')
  } catch {
    session.toast('Couldn’t copy; select the link instead', 'error')
  }
}
</script>

<template>
  <Modal :title="space.name" @close="emit('close')">
    <div class="flex flex-col items-center gap-4" data-testid="space-qr">
      <Avatar :id="space.id" :name="space.name" :size="240" square :qr="url" />
      <p class="mono max-w-full text-center break-all text-text-secondary select-all" data-testid="space-qr-url">{{ url }}</p>
      <p class="text-center text-xs text-text-muted">
        Opens this space on a phone or another device where you're signed in. It's not an invite: people who aren't
        members can't get in with it.
      </p>
      <button class="btn-outline" @click="copy">Copy link</button>
    </div>
  </Modal>
</template>
